const FETCH_CITIES_REQUEST = "FETCH_CITIES_REQUEST";
const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
const FETCH_CITIES_FAILURE = "FETCH_CITIES_FAILURE";

export default {
  FETCH_CITIES_REQUEST,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAILURE,
};
